import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {ObservationVariant} from 'web-app/react/entities/observations/constants';

const domain = 'MODALS/DRAFT_MANAGER';
export const {action: show} = createAction(
    `${domain}/SHOW`,
    (
        newPostRecipients,
        context,
        feedItem,
        disablePosts = false,
        disableObservations = false,
        observationVariant = ObservationVariant.REGULAR_OBSERVATION,
    ) => ({newPostRecipients, context, feedItem, disablePosts, disableObservations, observationVariant}),
);

/**
 * @deprecated Use ObservationEditorModal instead
 */
export const {action: showObservation} = createAction(
    `${domain}/SHOW_OBSERVATION`,
    (newPostRecipients, observationVariant = ObservationVariant.REGULAR_OBSERVATION) => ({
        newPostRecipients,
        observationVariant,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

/**
 * @deprecated Use ObservationEditorModal instead
 */
export const {action: showObservationDraft} = createAction(
    `${domain}/EDIT_OBSERVATION_DRAFT`,
    (observationId, observationVariant, selectedRecipients) => ({
        observationId,
        observationVariant,
        selectedRecipients,
    }),
);
